module.exports = __webpack_public_path__ + "static/img/cont60 (6).5f2fab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont60 (6).jpg
// module id = 4H70
// module chunks = 0